import {VOLUME_CHANGE} from '../actions/volume';

export default(state = 0.8, action) => {
    switch (action.type) {
        case VOLUME_CHANGE:
            return parseFloat(action.value);
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/volume.js